<template>
  <div class="home">
    <div class="home-box" v-if="!IsMobile">
      <div v-for="(item,index) in homeCarousel" :key="item.id" :class="{'show':showIndex===(index+1)}" class="home-carousel" :style="{backgroundImage:`url(${item.carouselPath})`}" />
    </div>
    <div v-if="IsMobile" class="home-box">
      <img v-for="(item,index) in homeCarousel" :key="item.id" :class="{'show':showIndex===(index+1)}" class="home-carousel" :src="item.carouselPath"/>
      <div class="bottom-img-title">一<span>最新设计</span>一</div>
      <a v-for="(item) in bottomImg" :key="item.id" :href="item.jumpPath" class="bottom-img"><img :src="item.path"></a>
    </div>
    <img :src="homeBottom" class="bottom-gif" v-if="homeBottom">
  </div>

</template>

<script>
import Vue from "vue";
import { IsMobile } from "@/utils";
export default Vue.extend({
  name: "",
  data() {
    return {
      homeCarousel: [],
      bottomImg: [],
      homeBottom: null,
      IsMobile,
      showIndex: 1,
    };
  },
  created() {
    this.getList();
    this.getHomeConfig();
    this.getBottomImgList();
  },
  methods: {
    getList() {
      this.$https.get("/api/carousel/getCarousel").then((res) => {
        this.homeCarousel = res.data;
        const len = this.homeCarousel.length;
        const timer = setInterval(() => {
          if (this.showIndex == len) {
            this.showIndex = 0;
          }
          this.showIndex++;
        }, 3000);
        this.$once("hook:beforeDestroy", () => {
          clearInterval(timer);
        });
      });
    },
    getBottomImgList() {
      this.$https.get("/api/homeImg/getHomeImg").then((res) => {
        this.bottomImg = res.data;
      });
    },
    getHomeConfig() {
      this.$https
        .get("/api/homeConfig/getConfigByType", {
          params: {
            type: 2,
          },
        })
        .then((res) => {
          const img = res.data;
          img?.id && (this.homeBottom = img.imgPath);
        });
    },
  },
});
</script>